import React from 'react'
import { Text, View } from 'oio-react'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { InitiativeDiscussionIcon, ViewGlyph12Icon } from 'assets/icons'

// TODO: This will be deprecated soon #PR #967
const BlogListItemCard = ({
   avatarUrl,
   bodyTextColor,
   bodyTextSize,
   borderStyle,
   coverUrl,
   linkTo,
   name,
   nameTextSize,
   numThreadEntries,
   numViews,
   pinned,
   privacy,
   publishDate,
   subtitle,
   summary,
   textColor
}) => (
   <Link to={linkTo}>
      <View
         display="flex"
         justifyContent="space-between"
         height="100%"
         padding="20px 5px[a-b] 30px 0px[c-f]"
         borderBottom={borderStyle}>
         <View
            display="flex"
            flexFlow="column[a-b] row[c-f]"
            flex="1 1 auto"
            paddingRight="20px[a-d] 100px[e-f]">
            <View
               flex="0 0 auto"
               width="160px[a-d] 180px[e-f]"
               paddingBottom="5px">
               <Text
                  size="2"
                  lineHeight="150%"
                  color="#888">
                  {publishDate}
               </Text>
            </View>
            <View>
               <Text
                  size="3.5"
                  lineHeight="130%"
                  weight="medium"
                  color={textColor}>
                  {name}
               </Text>
               {(summary || subtitle) && (
                  <View
                     maxWidth="600px"
                     margin="5px 0 0 0"
                     maxHeight="60px"
                     opacity="0.6"
                     style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                     }}>
                     <Text
                        size={bodyTextSize}
                        lineHeight="140%"
                        color={bodyTextColor}>
                        {subtitle}
                        {!subtitle && (
                           <div
                              dangerouslySetInnerHTML={{
                                 __html: summary
                              }}
                           />
                        )}
                     </Text>
                  </View>
               )}
               {(privacy === 'draft' || numThreadEntries > 0 || numViews > 0) && (
                  <View
                     display="flex"
                     alignItems="center"
                     padding="10px 0 0 0">
                     {privacy === 'draft' && (
                        <View
                           display="flex"
                           alignItems="center"
                           backgroundColor="rgba(247, 183, 124, 1)"
                           borderRadius="2px"
                           padding="5px"
                           marginRight="15px">
                           <Text
                              size="0.7"
                              lineHeight="100%"
                              color="#000"
                              weight="medium"
                              transform="uppercase">
                              {privacy}
                           </Text>
                        </View>
                     )}
                     {numThreadEntries > 0 && (
                        <View display="flex" alignItems="center" marginRight="15px" opacity="0.5">
                           <View marginRight="5px">
                              <InitiativeDiscussionIcon
                                 width="10px"
                                 height="10px"
                                 color={textColor}
                              />
                           </View>
                           <Text size="1.5" color={textColor}>
                              {`${pluralize('Comments', numThreadEntries, true)} `}
                           </Text>
                        </View>
                     )}
                     {numViews > 0 && (
                        <View display="flex" alignItems="center" opacity="0.5">
                           <View margin="0px 5px 0px 0px">
                              <ViewGlyph12Icon
                                 width="12px"
                                 height="12px"
                                 color={textColor}
                              />
                           </View>
                           <Text size="1.5" color={textColor}>
                              {pluralize('Views', numViews, true)}
                           </Text>
                        </View>
                     )}
                  </View>
               )}
            </View>
         </View>
         <View
            width="60px[a] 80px[b] 100px[c] 80px[d] 100px[e-f]"
            flex="0 0 auto">
            {coverUrl && (
               <View
                  paddingTop="100%"
                  backgroundColor="#eee"
                  backgroundImage={`url(${coverUrl})`}
                  backgroundSize="cover"
                  backgroundPosition="center center"
                  backgroundRepeat="no-repeat"
                  borderRadius="8px"
               />
            )}
         </View>
      </View>
   </Link>
)

BlogListItemCard.propTypes = {
   avatarUrl: PropTypes.string,
   bodyTextColor: PropTypes.string,
   bodyTextSize: PropTypes.string,
   borderStyle: PropTypes.string.isRequired,
   coverUrl: PropTypes.string,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   nameTextSize: PropTypes.string,
   numThreadEntries: PropTypes.number.isRequired,
   numViews: PropTypes.number.isRequired,
   pinned: PropTypes.bool,
   privacy: PropTypes.string.isRequired,
   publishDate: PropTypes.string.isRequired,
   subtitle: PropTypes.string,
   summary: PropTypes.string,
   textColor: PropTypes.string
}

BlogListItemCard.defaultProps = {
   avatarUrl: '/assets/images/avatarPlaceholder.svg',
   bodyTextColor: '#555',
   bodyTextSize: '2.5',
   coverUrl: undefined,
   nameTextSize: '3',
   pinned: false,
   subtitle: undefined,
   summary: undefined,
   textColor: '#000'
}

export default BlogListItemCard
